/* src/app/private/components/temp-student-profile/update-student-admission-details/update-student-admission-details.component.scss */
.profile-input {
  background-color: var(--secondry-light-gray) !important;
  border: none !important;
}
.profile-select {
  background-color: var(--secondry-light-gray) !important;
  border: none !important;
}
.p-datepicker-inpu {
  background-color: var(--secondry-light-gray) !important;
  border: none !important;
}
/*# sourceMappingURL=update-student-admission-details.component.css.map */
